import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AddCircleBlue, CustomDelete, FullTable } from 'components';
import {PermissionList, RolePermission, sortListByKey, useModal} from 'utils';
import { clientActions } from 'store';
import { ASSIGN_ACTION_TYPE, assignmentBody, assignmentHead, staffAssignmentNotYet } from './constants';
import { AssignStaffToClient } from './common';

const REMOVE_ACTION_TYPE = 'REMOVE_STAFF';

export const ClientAssignment = ({}) => {
    const client = useSelector((state) => state.client.clientItemInfo);
    const clientStaffs = useSelector((state) => state.client.clientStaffs);
    const dispatch = useDispatch();
    const params = useParams();
    const { open, close } = useModal();

    useEffect(() => {
        dispatch(clientActions.getAssignedStaffs(params?.id));
    }, []);

    const handleClickButton = (item, name) => {
        if (name === 'delete') {
            open(
                <CustomDelete
                    text={`Are you sure you want to unassign this staff from the client?`}
                    info="Unassign Staff?"
                    innerText={'Unassign'}
                    handleDel={() => dispatch(clientActions.removeClientStaff(client?.id, item?.assignedId))}
                    handleClose={() => close()}
                    actionType={REMOVE_ACTION_TYPE}
                />
            );
        }
        if (name === 'edit') {
            open(<AssignStaffToClient item={item} />);
        }
    };

    return (
        <div className="assign-staff-wrapper">
            {RolePermission([PermissionList.CLIENT_STAFF_ASSIGNMENT?.code]) &&
            <div className="header-action-btn">
                <AddCircleBlue text={'Assign Staff'} handleClick={() => open(<AssignStaffToClient />)} />
            </div>
            }
            <FullTable
                head={assignmentHead}
                body={assignmentBody}
                loadingType={ASSIGN_ACTION_TYPE}
                list={sortListByKey(clientStaffs, 'staffFullName')}
                handleClickButton={handleClickButton}
                notYet={staffAssignmentNotYet}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
